import { Skeleton } from "@tudigo-monorepo/web-tudigo-components";

export function InvestorTestimonialsSliderSkeleton() {
  return (
    <div className="flex h-fit w-full flex-col gap-6 md:flex-row">
      <article className="flex flex-1 flex-col items-start gap-6 lg:flex-row-reverse">
        <Skeleton className="flex h-[160px] w-full md:h-[600px] lg:min-w-[320px] lg:max-w-[320px] xl:h-[320px] 2xl:min-w-[464px] 2xl:max-w-[664px]" />
        <Skeleton className="flex h-[350px] w-full flex-col items-start gap-y-6 md:h-full lg:w-fit lg:min-w-[364px] xl:w-full" />
      </article>
      <aside className="h-auto w-full md:w-fit">
        <div className="flex items-center gap-x-3 gap-y-6 md:grid md:grid-cols-1">
          <Skeleton className="h-16 w-16 lg:h-20 lg:w-20" />
          <Skeleton className="h-16 w-16 lg:h-20 lg:w-20" />
          <Skeleton className="h-16 w-16 lg:h-20 lg:w-20" />
        </div>
      </aside>
    </div>
  );
}
